import axios from "axios";

const headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
};

const api = axios.create({
    baseURL: "https://portal.micasitaapp.com/",
});

api.defaults.headers = headers;

api.interceptors.request.use((config) => config);

api.interceptors.response.use(
    (response) => response.status === 200 ? response.data : response,

    async (error) => Promise.reject(error?.response?.data ? error.response : error)
);
export default api;
